<template>
  <div class="AOAP">
    <div class="TitleTop">
      开户申请进度
    </div>

    <div class="procedure">
      <div class="procedureBox">
        <!-- 未备案 -->
        <div class="procedureImOrText" v-if="ProcessStatusArr[0].DoneStatus == 1">
          <img src="@/assets/channel/OpenAccountProcess/NotFiled.png" alt="未备案" class="OpenAccountProcessImg">
          未备案
        </div>
        <div class="procedureImOrText" v-else-if="ProcessStatusArr[0].DoneStatus == 2">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="未备案" class="OpenAccountProcessImg">
          未备案
        </div>
        <!-- 虚线 -->
        <div  :class="[ProcessStatusArr[1].DoneStatus == 2 ? 'line' : 'lineNO']">
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-if="ProcessStatusArr[1].DoneStatus == 0">
          <img src="@/assets/channel/OpenAccountProcess/FilingCompleted-H.png" alt="备案完成" class="OpenAccountProcessImg">
          备案完成
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[1].DoneStatus == 1">
          <img src="@/assets/channel/OpenAccountProcess/FilingCompleted.png" alt="备案完成" class="OpenAccountProcessImg">
          备案完成
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[1].DoneStatus == 2">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="备案完成" class="OpenAccountProcessImg" >
          备案完成
        </div>
        <!-- 虚线 -->
        <div :class="[ProcessStatusArr[2].DoneStatus == 2 ? 'line' : 'lineNO']">
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-if="ProcessStatusArr[2].DoneStatus == 0">
          <!-- 未进行 -->
          <img src="@/assets/channel/OpenAccountProcess/ContractMaking-H.png" alt="备案完成" class="OpenAccountProcessImg">
          合同制作中
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[2].DoneStatus == 1">
          <!-- 正在进行 -->
          <img src="@/assets/channel/OpenAccountProcess/ContractMaking.png" alt="备案完成" class="OpenAccountProcessImg">
          合同制作中
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[2].DoneStatus == 2">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="备案完成" class="OpenAccountProcessImg">
          合同制作中
        </div>
        <!-- 虚线 -->
        <div class="line" :class="[ProcessStatusArr[3].DoneStatus == 2 ? 'line' : 'lineNO']">
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-if="ProcessStatusArr[3].DoneStatus == 0">
          <!-- 未进行 -->
          <img src="@/assets/channel/OpenAccountProcess/ContractSeal-H.png" alt="合同用印" class="OpenAccountProcessImg">
          合同用印
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[3].DoneStatus == 1">
          <!-- 正在进行 -->
          <img src="@/assets/channel/OpenAccountProcess/ContractSeal.png" alt="合同用印" class="OpenAccountProcessImg">
          合同用印
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[3].DoneStatus == 2">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="合同用印" class="OpenAccountProcessImg">
          合同用印
        </div>
        <!-- 虚线 -->
        <div class="line" :class="[ProcessStatusArr[4].DoneStatus == 2 ? 'line' : 'lineNO']">
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-if="ProcessStatusArr[4].DoneStatus == 0">
          <!-- 未进行 -->
          <img src="@/assets/channel/OpenAccountProcess/contract-H.png" alt="合同已签订" class="OpenAccountProcessImg">
          合同已签订
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[4].DoneStatus == 1">
          <!-- 正在进行 -->
          <img src="@/assets/channel/OpenAccountProcess/contract.png" alt="合同已签订" class="OpenAccountProcessImg">
          合同已签订
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[4].DoneStatus == 2">
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="合同已签订" class="OpenAccountProcessImg">
          合同已签订
        </div>

        <!-- 虚线 -->
        <div class="line" :class="[ProcessStatusArr[5].DoneStatus == 2 ? 'line' : 'lineNO']">
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;"  v-if="ProcessStatusArr[5].DoneStatus == 0">
          <!-- 未进行 -->
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount-H.png" alt="开户完成" class="OpenAccountProcessImg">
          开户完成
        </div>
        <div class="procedureImOrText" style="margin-left: 10px;" v-else-if="ProcessStatusArr[5].DoneStatus == 2">
          <!-- 正在进行 -->
          <img src="@/assets/channel/OpenAccountProcess/openAnAccount.png" alt="开户完成" class="OpenAccountProcessImg">
          开户完成
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import {
  OpenAccountGetOpenAccountStatus,
} from '@/api/channel'
export default {
  components: {},
  props: {},
  data() {
    return {
      ProcessStatusArr: []
    }
  },
  created() {
    this.OpenAccountGetOpenAccountStatus()
  },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    // 进度流程接口
    async OpenAccountGetOpenAccountStatus() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,0.3)",
      });
      let {
        code,
        data,
        message
      } = await OpenAccountGetOpenAccountStatus({})
      if(code == 0){
        this.ProcessStatusArr = data
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.AOAP {
  .TitleTop {
    width: 100%;
    height: 45px;
    line-height: 45px;
    // border: 1px solid rebeccapurple;
    border-bottom: 1px solid #eaecef;
    font-size: 16px;
    font-weight: 500;
    color: #16181a;
  }
  .procedure {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #eaecef;

    .procedureBox {
      width: 100%;
      height: 33px;
      // background-color: red;
      margin-top: 23px;
      display: inline-block;

      .procedureImOrText {
        font-weight: normal;
        font-size: 16px;
        color: #00266d;
        display: inline-block;
      }
    }
  }

  .OpenAccountProcessImg {
    width: 32px;
    height: 32px;
    vertical-align: middle;
    margin-right: 5px;
  }
}
.line {
  display: inline-block;
  width: 30px;
  height: 1px;
  border-bottom: 1px dashed #00266d;
  margin-left: 10px;
  margin-bottom: 5px;
}
.lineNO {
  display: inline-block;
  width: 30px;
  height: 1px;
  border-bottom: 1px dashed #c8cbd1;
  margin-left: 10px;
  margin-bottom: 5px;
}
</style>